import React from "react";
import DrpEeduHeader from "../../components/DrpEeduHeader";
import DrpEduNavbar from "../../components/DrpEduNavbar";
import Footer from "../../components/Footer";

const RussiaMbbs = () => {
  return (
    <>
      <DrpEeduHeader />
      <DrpEduNavbar />{" "}
      <div className="mbbs-country-page">
        <section className="country-header">
          <h2 className="country-title">🩺 MBBS in Russia</h2>
        </section>

        <section className="details-section">
          <div className="detail-item">
            <h3 className="detail-title">Degree Awarded:</h3>
            <p className="detail-text">M.D. (equivalent to MBBS in India)</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Duration:</h3>
            <p className="detail-text">
              6 years (including internship/clinical training)
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Eligibility:</h3>
            <ul className="detail-list">
              <li>10+2 with Physics, Chemistry, Biology, and English</li>
              <li>Minimum 50% marks (40% for SC/ST/OBC)</li>
              <li>NEET qualification is mandatory (for Indian students)</li>
            </ul>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Medium of Instruction:</h3>
            <p className="detail-text">
              English (with Russian language taught for local interaction)
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Admission:</h3>
            <p className="detail-text">
              Direct (no entrance test); based on 12th marks and NEET score
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Recognition:</h3>
            <p className="detail-text">
              Universities must be recognized by NMC (India), WHO, and WFME.
            </p>
          </div>
        </section>

        <section className="universities-section">
          <h2 className="section-title">🎓 Top MBBS Universities in Russia</h2>
          <div className="university-list">
            <div className="university-card">
              <h3 className="university-name">
                Lomonosov Moscow State University
              </h3>
              <p className="university-description">
                Russia’s #1 university. Highly prestigious with strong research
                and clinical facilities.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Sechenov First Moscow State Medical University
              </h3>
              <p className="university-description">
                Oldest medical university in Russia. NMC, WHO, and ECFMG
                approved.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Pirogov Russian National Research Medical University (RNRMU),
                Moscow
              </h3>
              <p className="university-description">
                Leading institution for international students. Offers fully
                English-taught MBBS program.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">Kazan Federal University</h3>
              <p className="university-description">
                Over 200 years old. Ranked among Russia’s top public
                universities.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                People’s Friendship University of Russia (RUDN), Moscow
              </h3>
              <p className="university-description">
                Internationally known for multicultural student population. MBBS
                taught in English.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Saint Petersburg State Pediatric Medical University
              </h3>
              <p className="university-description">
                Specializes in pediatric medicine and general MBBS. Recognized
                by NMC and WHO.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Bashkir State Medical University
              </h3>
              <p className="university-description">
                Popular among Indian students. Affordable tuition and
                English-medium programs.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Volgograd State Medical University
              </h3>
              <p className="university-description">
                Good clinical exposure and infrastructure. NMC approved.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Crimean Federal University (Vernadsky CFU)
              </h3>
              <p className="university-description">
                Offers low-cost MBBS in English. Located in Crimea (Note: check
                NMC acceptance status due to Crimea's political status).
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Siberian State Medical University
              </h3>
              <p className="university-description">
                Among top 5 medical universities in Russia. Strong academic and
                research environment.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default RussiaMbbs;
